import type { IntentActionType } from "./types";

export const TOOL_TO_ACTION_TYPE: Record<string, IntentActionType> = {
  manage_service: "MANAGE_SERVICE",
  manage_category: "MANAGE_CATEGORY",
  sort_items: "SORT_ITEMS",
  batch_update_services: "BATCH_UPDATE_SERVICES",
  bulk_update_services: "BULK_UPDATE_SERVICES",
  copy_services: "COPY_SERVICES",
  update_worker_services: "UPDATE_WORKER_SERVICES",
  batch_create_services: "BATCH_CREATE_SERVICES",
  batch_create_categories: "BATCH_CREATE_CATEGORIES",
  batch_update_categories: "BATCH_UPDATE_CATEGORIES",
  commit_config_change: "COMMIT_CONFIG_CHANGE",
  update_operating_hours: "UPDATE_OPERATING_HOURS",
  update_salon_profile: "UPDATE_SALON_PROFILE",
  update_salon_contact: "UPDATE_SALON_CONTACT",
  create_holiday: "CREATE_HOLIDAY",
  update_holiday: "UPDATE_HOLIDAY",
  create_team_member: "CREATE_TEAM_MEMBER",
  update_team_member: "UPDATE_TEAM_MEMBER",
  update_worker_service_restrictions: "UPDATE_WORKER_SERVICE_RESTRICTIONS",
  create_appointment: "CREATE_APPOINTMENT",
  update_appointment: "UPDATE_APPOINTMENT",
  batch_update_appointments: "BATCH_UPDATE_APPOINTMENTS",
  update_appointment_status: "UPDATE_APPOINTMENT_STATUS",
  assign_worker: "ASSIGN_APPOINTMENT_WORKER",
  create_customer: "CREATE_CUSTOMER",
  create_discount: "CREATE_DISCOUNT",
  update_discount: "UPDATE_DISCOUNT",
  delete_discount: "DELETE_DISCOUNT",
};
